import { useEffect } from 'react'

const SITE_NAME = 'Darren Flowers-Finley'

export const usePageTitle = (title) => {
  useEffect(() => {
    if (!title) return undefined
    document.title = `${title} · ${SITE_NAME}`
    return undefined
  }, [title])
}
